import './App.css';
import SmartChatBot from './components/SmartChatBot.jsx'; 
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';

import 'bootstrap/dist/css/bootstrap.min.css'
import { Project } from './components/Project';
import { Stack } from './components/Stack';

function App() {
  return (
    <div className="App">
      <SmartChatBot />
      <NavBar />
      <Banner />
      <Project />
      <Stack />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
